export const users = {
  reset: {
    error:
      "Esta acción no se puede realizar en este momento. La cuenta del usuario objetivo no ha sido modificada. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, por favor cree <a>un ticket de Problema de Cuenta</a> en nuestro servicio de asistencia.",
    password: {
      action: "Restablecer contraseña",
      info: "Restablece la contraseña del Usuario enviándole un correo electrónico con un enlace para restablecer su contraseña. <br/><br/> Nota: esta acción no tiene efecto si el usuario inicia sesión a través de SSO. <br/><br/> Por favor, consulte <docsLink>esta página en nuestra documentación de ayuda</docsLink> para solucionar problemas de inicio de sesión.",
      warning:
        "Este enlace es <b>válido solo por 1 hora</b>, por lo tanto, coordine un tiempo de recuperación con el usuario objetivo según corresponda. Si se pierde la ventana de 1 hora, el usuario quedará bloqueado de su cuenta hasta que esta acción de restablecimiento de contraseña se realice nuevamente.",
    },
    mfa: {
      action: "Restablecer MFA",
      info: "Restablece el autenticador de múltiples factores del Usuario (Okta Verify, Google Authenticator o ambos). Se les solicitará que restablezcan su MFA nuevamente cuando vuelvan a iniciar sesión. </br></br> Por favor, consulte <docsLink>esta página en nuestra documentación de ayuda</docsLink> para solucionar problemas de inicio de sesión.",
    },
  },
  deactivate: "Desactivar",
  resend: "Reenviar",
  After_confirmation_this_invitation_will_be_deleted_and_user_lose_access:
    "Después de la confirmación, esta invitación se eliminará y el usuario perderá el acceso.",
  After_confirmation_this_person_will_be_deactivate_and_lose_access:
    "Después de la confirmación, esta persona será desactivada y perderá el acceso.",
  Are_you_sure_you_want_to_deactivate: "¿Estás seguro de que quieres desactivar?",
  Are_you_sure_you_want_to_delete_invitation: "¿Estás seguro de que deseas eliminar la invitación?",
  Assign_roles: "Asignar roles",
  Create_another_user: "Crear otro usuario",
  Edit_User: "Editar usuario",
  Email: "Correo electrónico",
  activate: "Activar",
  First_Name: "Nombre de pila",
  Here_you_will_manage_companys_users: "Aquí gestionarás los usuarios de la empresa.",
  Invite_New_User: "Invitar a nuevos usuario",
  Invite_New_Users: "Invitar a nuevos usuarios",
  Job_Title: "Título profesional",
  Roles: "Roles",
  Status: "Estado",
  Surname: "Apellido",
  Update_user: "Actualizar usuario",
  Use_this_window_to_setup_a_new_user:
    "Utilice esta ventana para invitar a un nuevo usuario. Un usuario puede tener varios roles excepto el rol de `Verificador`.",
  Users: "Usuarios",
  users_management: "Gestión de usuarios",
  no_users_added_yet: "Aún no has agregado ningún usuario.",
  status_options: {
    invited: "Invitado",
    invitation_expired: "Invitación expirada",
    active: "Activo",
    deactivated: "Desactivado",
  },
} as const;
